import { render, staticRenderFns } from "./AddBarcode.vue?vue&type=template&id=2bc11f64&scoped=true"
import script from "./AddBarcode.vue?vue&type=script&lang=js"
export * from "./AddBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc11f64",
  null
  
)

export default component.exports